import { useCallback } from "react";
import { IListaCbo } from "../../../application/models/geo-veles/IListaCbo";
import { useAxiosInstances } from "../../axios-instance";

export const useListaCboApi = () => {
  const { axiosAuthInstance } = useAxiosInstances();



  const createListaCboApi = useCallback(
    async (data: { Nome: string; IdUsuario: number }): Promise<IListaCbo> => {
      try {
        const result = await axiosAuthInstance.post("/geo-veles/lista-cbo/", {
          idUsuario: data.IdUsuario,
          nome: data.Nome,
        });

        return result.data.ListaCbo;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const updateListaCboApi = useCallback(
    async (data: {
      idVelesGeoListaCBO: number;
      idUsuario: number;
      Cbos: string[];
      nome: string;
    }): Promise<IListaCbo> => {
      try {
        const result = await axiosAuthInstance.put(`/geo-veles/lista-cbo/cbo`, {
          IdVelesGeoListaCBO: data.idVelesGeoListaCBO,
          IdUsuario: data.idUsuario,
          CBOs: data.Cbos,
          Nome: data.nome,
        });
        return result.data;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const updateStatusListaCboApi = useCallback(
    async (data: {
      idVelesGeoListaCbo: number;
      idUsuario: number;
      status: boolean;
    }): Promise<IListaCbo> => {
      try {
        const result = await axiosAuthInstance.put(
          "/geo-veles/lista-cbo/status",
          {
            IdVelesGeoListaCbo: data.idVelesGeoListaCbo,
            IdUsuario: data.idUsuario,
            Ativa: data.status, 
          }
        );
        return result.data.ListaCBO;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );


const getByIdListaCboApi = useCallback(
  async (idLista: number): Promise<any> => {
    try {
      const result = await axiosAuthInstance.get(`/geo-veles/lista-cbo/lista/${idLista}`);
      const listaArray = result.data.ListaCbo; 
      if (!Array.isArray(listaArray) || listaArray.length === 0) {
        throw new Error('Lista CBO não encontrada');
      }
      return listaArray[0]; // retorna o primeiro (e único) objeto
    } catch (error) {
      throw error;
    }
  },
  [axiosAuthInstance]
);

  const getByIdClienteListaCboApi = useCallback(
    async (idCliente: number): Promise<IListaCbo[]> => {
      try {
        const result = await axiosAuthInstance.get(
          `/geo-veles/lista-cbo/cliente/${idCliente}`
        );
        return result.data;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  return {
    createListaCboApi,
    updateListaCboApi,
    updateStatusListaCboApi,
    getByIdListaCboApi,
    getByIdClienteListaCboApi,
  };
};
